import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import ColorSkeleton from './ColorSkeleton';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1300px !important;
  padding-top: 20px;

  .filters {
    width: 100%;
    display: flex;
  }

  .skeleton-buttons-container {
    span {
      margin-left: 15px;
    }
  }

  .grid-buttons {
    display: flex;
    span {
      margin-left: 5px;
    }
  }
`;

function FilterSkeleton() {
  const match = useRouteMatch();
  const isWallpaper = match.params.categorySlug.toLowerCase() === 'wallpaper';

  const isOutdoor = match.params.categorySlug.toLowerCase() === 'outdoor';

  return (
    <Wrapper className="container">
      <div className="filters">
        <ColorSkeleton />
        {/* <Color colors={colors} colorIds={colorIds} setColorIds={setColorIds} /> */}
        {!isWallpaper && (
          <div className="skeleton-buttons-container">
            <Skeleton width={200} height={56} />
            {!isOutdoor && <Skeleton width={200} height={56} />}
          </div>
        )}
      </div>

      {!isWallpaper && (
        <div className="grid-buttons">
          <Skeleton width={56} height={56} />
          <Skeleton width={56} height={56} />
        </div>
      )}
    </Wrapper>
  );
}

export default FilterSkeleton;

const DoubleGrid = styled.svg`
  margin-right: 10px;
  cursor: pointer;
  width: 45px;
  rect {
    stroke: ${({ selected }) => (selected ? '#2A5CAF' : '#C4C4C4')};
  }
`;

const ClearFilterButton = styled.button`
  visibility: ${({ showClear }) => (showClear ? 'visible' : 'hidden')};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  letter-spacing: 0.04em;
  color: #a83569;
  border: none;
  outline: none;
  background: white;
`;
export const DoubleGridIcon = ({ className, onClick, selected }) => {
  return (
    <DoubleGrid
      selected={selected}
      onClick={onClick}
      className={className}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="55"
        height="55"
        rx="1.5"
        fill="white"
        stroke="#2A5CAF"
      />
      <rect
        x="15.3569"
        y="14.2142"
        width="11.5714"
        height="11.5714"
        rx="1.5"
        fill="white"
        stroke="#2A5CAF"
      />
      <rect
        x="15.3569"
        y="29.0714"
        width="11.5714"
        height="11.5714"
        rx="1.5"
        fill="white"
        stroke="#2A5CAF"
      />
      <rect
        x="30.2144"
        y="14.2142"
        width="11.5714"
        height="11.5714"
        rx="1.5"
        fill="white"
        stroke="#2A5CAF"
      />
      <rect
        x="30.2144"
        y="29.0714"
        width="11.5714"
        height="11.5714"
        rx="1.5"
        fill="white"
        stroke="#2A5CAF"
      />
    </DoubleGrid>
  );
};

const SingleGrid = styled.svg`
  cursor: pointer;
  width: 45px;
  rect {
    stroke: ${({ selected }) => (selected ? '#2A5CAF' : '#C4C4C4')};
  }
`;

export const SingleGridIcon = ({ className, onClick, selected }) => {
  return (
    <SingleGrid
      selected={selected}
      onClick={onClick}
      className={className}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="55"
        height="55"
        rx="1.5"
        fill="white"
        stroke="#C4C4C4"
      />
      <rect
        x="22.2144"
        y="14.2142"
        width="11.5714"
        height="11.5714"
        rx="1.5"
        fill="white"
        stroke="#C4C4C4"
      />
      <rect
        x="22.2144"
        y="29.0714"
        width="11.5714"
        height="11.5714"
        rx="1.5"
        fill="white"
        stroke="#C4C4C4"
      />
    </SingleGrid>
  );
};
